import { useEffect } from "react";

import DeleteMatch from "@material-ui/icons/Delete";
import { Card, ListItem, ListItemAvatar } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import List from "@material-ui/core/List";

import { numberWithSpaces } from "../../../../utilities/formaters";

import { accountingConnector } from "../../../../services/accounting/connector";

function ConfirmedMatch() {
  return null;
}

const InvoicesContent = ({
  invoiceMatched,
  sumToSavelendTransferInvoices,
  sumToClientTransferInvoices,
  sumFromSavelendToClientTransferInvoices,
  toggleMatchedPaymentSendingFlag,
  confirmDateInvoice,
  setConfirmDateInvoice,
  openConfirmation,
  accounting,
  clearNumbersOnMount,
}) => {
  useEffect(
    () => clearNumbersOnMount(accounting.matchedInvoices.data.length),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const allTranferred = accounting.matchedInvoices.allTransferred;
  return (
    <div className="content-padding">
      <Card>
        <CardHeader
          title={"Bank transfers:"}
          subheader={
            <div>
              {sumToSavelendTransferInvoices > 0 ? (
                <div>
                  IncomingAccount To SavelendAccount:{" "}
                  <strong>
                    {numberWithSpaces(sumToSavelendTransferInvoices)} kr
                  </strong>
                  ,{" "}
                </div>
              ) : undefined}
              {sumToClientTransferInvoices > 0 ? (
                <div>
                  IncomingAccount To ClientAccount:{" "}
                  <strong>
                    {numberWithSpaces(sumToClientTransferInvoices)} kr
                  </strong>
                </div>
              ) : undefined}
              {sumFromSavelendToClientTransferInvoices > 0 ? (
                <div>
                  SavelendAccount To ClientAccount:{" "}
                  <strong>
                    {numberWithSpaces(sumFromSavelendToClientTransferInvoices)}{" "}
                    kr
                  </strong>
                </div>
              ) : undefined}
            </div>
          }
        />
        <CardContent>
          <div>
            <div>
              <span>
                <strong>Total transferred:</strong> {allTranferred.totalAmount}{" "}
                kr
              </span>
              <br />
              <span>
                <strong>Done: </strong>
                {allTranferred.numberOfDone}/
                {accounting.matchedInvoices?.data.length > 0
                  ? accounting.matchedInvoices?.data.length
                  : allTranferred.plannedNumberToDo}
              </span>
            </div>
            <DatePicker
              inputVariant="outlined"
              className="small-datepicker"
              value={confirmDateInvoice}
              onChange={setConfirmDateInvoice}
              helperText="Confirm date"
              label="Confirm date"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={openConfirmation}
            >
              Confirm matched invoices
            </Button>
          </div>
          <List>
            {invoiceMatched.map((item, index) => {
              let isRemovedFromSending = item.RemoveFromSending;
              let icon = isRemovedFromSending ? (
                <DeleteMatch />
              ) : (
                <ConfirmedMatch />
              );

              return (
                <div className="row" key={item.Id}>
                  <div className="col-md-6">
                    <ListItem key={index} disabled={true}>
                      <ListItemAvatar>
                        <Avatar
                          backgroundColor={"rgb(81, 211, 130)"}
                          icon={icon}
                        />
                      </ListItemAvatar>
                      Payment Id: {item.Id} <br />
                      Ref code: {item.RefCode} <br />
                      Date entered: {item.DateEntered} <br />
                    </ListItem>
                  </div>
                  <div className="col-md-6">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={toggleMatchedPaymentSendingFlag.bind(
                        this,
                        "invoice",
                        item.Id,
                      )}
                    >
                      Toggle invoice sending
                    </Button>
                  </div>
                </div>
              );
            })}
          </List>
        </CardContent>
      </Card>
    </div>
  );
};

export default accountingConnector(InvoicesContent);
